"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = exports.Details = exports.CustomShade = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const Details = exports.Details = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  color: theme.palette.text.primary,
  fontSize: '1.2rem',
  '&:empty': {
    display: 'none'
  }
}));
const Divider = exports.Divider = (0, _mui.styled)('span')(({
  theme
}) => ({
  display: 'inline-block',
  margin: theme.spacing(2),
  marginBottom: 4,
  // Hardcoded value to vertically center in the inline element
  marginTop: 0,
  background: 'currentColor',
  borderRadius: '50%',
  height: 2,
  width: 2
}));
const CustomShade = exports.CustomShade = (0, _mui.styled)(_presentationComponents.Shade)(({
  theme
}) => ({
  marginRight: theme.spacing(2)
}));
//# sourceMappingURL=styles.js.map